import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetPasswordWithVerificationCodeMutationVariables = Types.Exact<{
  input: Types.ResetPasswordWithVerificationCodeInput;
}>;


export type ResetPasswordWithVerificationCodeMutation = { __typename?: 'Mutation', resetPasswordWithVerificationCode: { __typename?: 'ResetPasswordWithVerificationCodePayload', isReset: boolean } };


export const ResetPasswordWithVerificationCodeDocument = gql`
    mutation ResetPasswordWithVerificationCode($input: ResetPasswordWithVerificationCodeInput!) {
  resetPasswordWithVerificationCode(input: $input) {
    isReset
  }
}
    `;
export type ResetPasswordWithVerificationCodeMutationFn = Apollo.MutationFunction<ResetPasswordWithVerificationCodeMutation, ResetPasswordWithVerificationCodeMutationVariables>;

/**
 * __useResetPasswordWithVerificationCodeMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithVerificationCodeMutation, { data, loading, error }] = useResetPasswordWithVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordWithVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordWithVerificationCodeMutation, ResetPasswordWithVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordWithVerificationCodeMutation, ResetPasswordWithVerificationCodeMutationVariables>(ResetPasswordWithVerificationCodeDocument, options);
      }
export type ResetPasswordWithVerificationCodeMutationHookResult = ReturnType<typeof useResetPasswordWithVerificationCodeMutation>;
export type ResetPasswordWithVerificationCodeMutationResult = Apollo.MutationResult<ResetPasswordWithVerificationCodeMutation>;
export type ResetPasswordWithVerificationCodeMutationOptions = Apollo.BaseMutationOptions<ResetPasswordWithVerificationCodeMutation, ResetPasswordWithVerificationCodeMutationVariables>;
export const namedOperations = {
  Mutation: {
    ResetPasswordWithVerificationCode: 'ResetPasswordWithVerificationCode'
  }
}